import csatEmployersType from './action-types'
import { FetchCsatAgenciesPayload } from './types'

export const fetchCsatAgencies = ({ options }: { options: FetchCsatAgenciesPayload }) => ({
  type: csatEmployersType.ENTITIES_FETCH_BEGIN,
  options,
})

export type FetchCsatAgenciesAction = ReturnType<typeof fetchCsatAgencies>
